import { d as defineCustomElement } from '../chunks/vidstack-DoOmgEfT.js';
import { M as MediaPosterElement, i as MediaPlayButtonElement, g as MediaMuteButtonElement, d as MediaCaptionButtonElement, e as MediaFullscreenButtonElement, h as MediaPIPButtonElement, j as MediaSeekButtonElement, c as MediaAirPlayButtonElement, w as MediaVolumeSliderElement, u as MediaTimeSliderElement, v as MediaSliderPreviewElement, t as MediaSliderValueElement, s as MediaSliderThumbnailElement, m as MediaMenuElement, n as MediaMenuButtonElement, p as MediaMenuItemsElement, o as MediaMenuItemElement, k as MediaAudioRadioGroupElement, l as MediaCaptionsRadioGroupElement, q as MediaSpeedRadioGroupElement, r as MediaQualityRadioGroupElement, a as MediaThumbnailElement, f as MediaLiveButtonElement, b as MediaTimeElement } from '../chunks/vidstack-DoG3FlyX.js';
import { g as MediaLayoutElement, b as MediaControlsElement, c as MediaControlsGroupElement, j as MediaTooltipElement, k as MediaTooltipTriggerElement, l as MediaTooltipContentElement, h as MediaGoogleCastButtonElement, i as MediaToggleButtonElement, q as MediaSliderElement, s as MediaSliderChaptersElement, r as MediaSliderVideoElement, m as MediaMenuPortalElement, n as MediaChaptersRadioGroupElement, p as MediaRadioGroupElement, o as MediaRadioElement, a as MediaGestureElement, M as MediaCaptionsElement, d as MediaTitleElement, e as MediaChapterTitleElement, f as MediaSpinnerElement } from '../chunks/vidstack-CWofPlup.js';
import '../chunks/vidstack-D1JzjGR7.js';
import '../chunks/vidstack-awVFxJvn.js';
import '../chunks/vidstack-CerDQCFL.js';
import '../chunks/vidstack-B_9E7csz.js';
import '../chunks/vidstack-BYuWkQD6.js';
import '../chunks/vidstack-CMz4Bd8X.js';
import '../chunks/vidstack-i0oJKwBM.js';
import '../chunks/vidstack-CyIpzU-o.js';
import '../chunks/vidstack-B3EgHpRH.js';
import '../chunks/vidstack-2fIzRyOW.js';
import '../chunks/vidstack-XO9MYVWR.js';
import '../chunks/vidstack-ksPACRiU.js';
import '../chunks/vidstack-B5PAXpJX.js';
import '../chunks/vidstack-BrgZdpmU.js';
import '../chunks/vidstack-Bf6opHxk.js';
import '../chunks/vidstack-CbhL8rpf.js';

defineCustomElement(MediaLayoutElement);
defineCustomElement(MediaControlsElement);
defineCustomElement(MediaControlsGroupElement);
defineCustomElement(MediaPosterElement);
defineCustomElement(MediaTooltipElement);
defineCustomElement(MediaTooltipTriggerElement);
defineCustomElement(MediaTooltipContentElement);
defineCustomElement(MediaPlayButtonElement);
defineCustomElement(MediaMuteButtonElement);
defineCustomElement(MediaCaptionButtonElement);
defineCustomElement(MediaFullscreenButtonElement);
defineCustomElement(MediaPIPButtonElement);
defineCustomElement(MediaSeekButtonElement);
defineCustomElement(MediaAirPlayButtonElement);
defineCustomElement(MediaGoogleCastButtonElement);
defineCustomElement(MediaToggleButtonElement);
defineCustomElement(MediaSliderElement);
defineCustomElement(MediaVolumeSliderElement);
defineCustomElement(MediaTimeSliderElement);
defineCustomElement(MediaSliderChaptersElement);
defineCustomElement(MediaSliderPreviewElement);
defineCustomElement(MediaSliderValueElement);
defineCustomElement(MediaSliderThumbnailElement);
defineCustomElement(MediaSliderVideoElement);
defineCustomElement(MediaMenuElement);
defineCustomElement(MediaMenuButtonElement);
defineCustomElement(MediaMenuPortalElement);
defineCustomElement(MediaMenuItemsElement);
defineCustomElement(MediaMenuItemElement);
defineCustomElement(MediaAudioRadioGroupElement);
defineCustomElement(MediaCaptionsRadioGroupElement);
defineCustomElement(MediaSpeedRadioGroupElement);
defineCustomElement(MediaQualityRadioGroupElement);
defineCustomElement(MediaChaptersRadioGroupElement);
defineCustomElement(MediaRadioGroupElement);
defineCustomElement(MediaRadioElement);
defineCustomElement(MediaGestureElement);
defineCustomElement(MediaThumbnailElement);
defineCustomElement(MediaCaptionsElement);
defineCustomElement(MediaLiveButtonElement);
defineCustomElement(MediaTimeElement);
defineCustomElement(MediaTitleElement);
defineCustomElement(MediaChapterTitleElement);
defineCustomElement(MediaSpinnerElement);
